/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthInsuranceAliases {
  APPLICATION_BAR = 'application-bar',
  AVATAR_USER = 'avatar-user',
  DROP_DOWN_USUARIO = 'drop-down-usuario',
  FOOTER_0 = 'footer-0',
  FRAGMENT_ROUTES = 'fragment-routes',
  LAYOUT_HI = 'layout-hi',
  OPTION_EXIT = 'option-exit',
  OPTION_MY_DATA = 'option-my-data',
  PANEL_ROUTES = 'panel-routes',
}
export { HealthInsuranceAliases };
